<template>
    <transition name="wm-modal-transition">
        <div class="wm-modal" v-if="isActive" :style="{zIndex}">
            <section class="wm-modal-content">
                <header class="wm-modal-header">
                    <h4 class="wm-modal-title">{{ title }}</h4>
                    <div class="wm-modal-close" @click.prevent="close">&times;</div>
                </header>
                <div class="wm-modal-body">
                    <slot v-bind="{close, open}"/>
                </div>
            </section>
        </div>
    </transition>
</template>

<script>
export default {

    props: {
        zIndex: {
            type: Number,
            default: 1500
        },
        title: {
            type: String,
        },

        isActive: {type: Boolean},
    },

    methods: {
        open() {
            this.$emit('update:isActive', true)
        },

        close() {
            this.$emit('update:isActive', false)
        }
    },

    watch: {
        isActive(value)  {
            this.$emit('change', value);
            this.$emit(value ? 'opened' : 'closed')
        }
    }
}
</script>

<style scoped lang="scss">
// wm => Wallace Maxters => Stonks
$padding: 2rem;

.wm-modal {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1500;

    display: flex;
    flex-wrap: wrap;

    justify-content: center;
    align-items: center;



    >.wm-modal-content {
        background-color: #fff;
        width: 700px;
        max-width: 100%;
        overflow: hidden;


        position: relative;


        >.wm-modal-header {
            padding: $padding;
            background-color: var(--color-primary);
            color: #fff;

            >.wm-modal-title {
                font-size: 1.5rem;
                margin: 0;
            }
        }


        > .wm-modal-body{
            padding: $padding;
            background-color: #ffffff;
        }

    }


    .wm-modal-close {
        font-size: 2rem;
        font-weight: bold;
        position: absolute;
        right: 1.5rem;
        top: 0.5rem;
        cursor: pointer;
        color: #fff;
    }

}


.wm-modal-transition-enter-active {
    transition: all 500ms linear;
    opacity: 0;
}

.wm-modal-transition-enter-to {
    opacity: 1;
}

.wm-modal-transition-leave-active {
    opacity: 1;
    transition: all 500ms linear;
}


.wm-modal-transition-leave-to {
    opacity: 0;

}

</style>



// WEBPACK FOOTER //
// src/components/common/Modal/Base.vue